// extracted by mini-css-extract-plugin
export var avatar = "_og-3";
export var avatarContainer = "_og-2";
export var avatarSpacer = "_og-5";
export var avatarSpacerContainer = "_og-4";
export var avatarStackContainer = "_og-1";
export var bubble = "_og-0";
export var remainderBubble = "_og-6";